// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"433":"0aefd641","442":"45658264","717":"e3e33f60"}[chunkId] + ".chunk.js";
};